<template>
  <v-container fluid>
    <span class="title -tongue ml-5">Qual a tipologia do empreendimento/serviço a ser solicitado?</span>
    <v-form v-model="valid">
      <v-layout>
        <v-flex xs6>
          <v-autocomplete
              v-model="typology"
              :rules="[validationRules.required]"
              :items="typologies"
              :loading="isLoading"
              :no-data-text="noDataText"
              :search-input.sync="search"
              class="select-multiline"
              item-text="name"
              return-object
              persistent-hint
              label="Digite para buscar e selecione uma opção"
              required>

            <template slot="item" slot-scope="{ item }">
              <v-layout row class="py-2">
                <small class="grey--text my-1">
                  {{ item.code }}
                </small>

                <span class="ml-2">
                    {{ item.name }}
                  </span>
              </v-layout>
            </template>

          </v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs6>
          <v-alert
              value="true"
              type="info"
              outline>
            <ul>
              <li>
                Os códigos e nomeclaturas aqui listadas seguem o Anexo I da Resolução
                CEPRAM 10/2018, que poderá ser visualizada <a
                  href="http://www.ima.al.gov.br/wizard/docs/RESOLUC%CC%A7A%CC%83O%20CEPRAM%20N%C2%BA%2010-2018.pdf"
                  target="_blank">
                clicando aqui</a>. Lembrando que para uma tipologia ser selecionada,
                a mesma deverá possuir um Tipo de Estudo Ambiental associada.
              </li>
              <li>
                De acordo com a <a
                  href="https://www.ibama.gov.br/phocadownload/legislacao/sinaflor/2014-12-24-IN-Ibama-21-sinaflor.pdf"
                  target="_blank">
                Instrução Normativa IBAMA n° 21, de 24 de dezembro de 2014</a> ,
                em observância dos arts. 35 e 36 da Lei nº 12.651, de 25 de maio de 2012
                as solicitações de emissão de autorizações de Supressão
                de Vegetação, deverão utilizar o
                <a href="https://servicos.ibama.gov.br/ctf/sistema.php" target="_blank">SINAFLOR</a>.
              </li>
              <li>
                Os boletos para a tipologia 12.13.03 (SISPASS – Criador Amador de Passeriformes)
                deverão ser emitidos diretamente pelo SISPASS após homologação do
                cadastro pelo IMA.
              </li>
              <li>
                Outros serviços que podem ser solicitados:
                <ul>
                  <li>Certidão (98.01.00)</li>
                  <li>Dispensa de Licenciamento (98.02.00)</li>
                  <li>Defesa de Auto de Infração (98.03.00)</li>
                  <li>Solicitações Diversas (98.04.00)</li>
                  <li>Atendimento a Condicionantes (98.05.00)</li>
                </ul>
              </li>
            </ul>
          </v-alert>
        </v-flex>
      </v-layout>
      <v-layout v-if="typology">
        <v-flex xs6 v-for="(tp, index) in technicalParameters" :key="tp.id">
          <v-text-field
              type="number"
              :rules="[validationRules.required]"
              :label="tp.name"
              v-model="technicalParametersFilled[index].value"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout v-if="typology">
        <v-flex class="pr-1" xs3>
          <v-autocomplete
              v-model="degradingPotentialForTax"
              :rules="[validationRules.required]"
              :items="degradingPotentialsForTax"
              :label="degradingPotentialParameterName"
              no-data-text="Nenhum resultado com o termo buscado"
              item-text="name"
              item-value="id"
              persistent-hint
              return-object
              required>
          </v-autocomplete>
        </v-flex>
        <v-flex class="pl-1" xs3>
          <v-autocomplete
              v-model="sizeForTax"
              :rules="[validationRules.required]"
              :items="sizesForTax"
              :label="sizeParameterName"
              no-data-text="Nenhum resultado com o termo buscado"
              item-text="name"
              item-value="id"
              persistent-hint
              return-object
              required>
          </v-autocomplete>
        </v-flex>
      </v-layout>


      <v-alert outline color="error" icon="mdi-alert" :value="showNotQualify" class="text-md-center mt-3">
        O seu requerimento não se aplica ao Licenciamento Ambiental por Compromisso, por isso será necessário
        realizar o Licenciamento Ambiental Ordinário
      </v-alert>


      <v-divider class="mt-3 mb-3"/>

      <v-layout>
        <v-flex xs6>
          <v-layout justify-space-between>
            <v-btn flat @click="previousStep()">Voltar</v-btn>
            <v-btn
                color="primary"
                :disabled="!valid"
                @click="mountFramework()"
            >
              Continuar
              <v-icon small right>mdi-arrow-right</v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import TypologyService from '@/services/applications/configurations/TypologyService';
import TechnicalParameterService from '@/services/applications/configurations/TechnicalParameterService';
import validationRules from '@/mixins/validation-rules';
import {reduce} from 'lodash'

export default {
  name: 'FrameworkStep',
  data() {
    return {
      validationRules,
      valid: false,

      typologies: [],
      typology: null,

      technicalParameters: [],
      technicalParametersFilled: [],

      degradingPotentialsForTax: [],
      degradingPotentialParameterName: '',
      degradingPotentialForTax: '',

      sizesForTax: [],
      sizeParameterName: '',
      sizeForTax: '',

      isLoading: false,
      timeout: null,
      search: '',
      qualifySimplifiedTechnicalParameters: null,
      showNotQualify: false,
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    ...mapActions('newApplication', ['nextStep', 'previousStep', 'setFrameworkEntity', 'setApplicationTypesAvailable', 'setValidSteps']),
    mountFramework() {
      const technicalParametersFilled = this.technicalParametersFilled.map((item) => {
        return {id: item.id, name: item.name, value: item.value.replace(',', '.')};
      });
      const payload = {
        typology: this.typology,
        technicalParametersFilled,
        degradingPotentialForTax: this.degradingPotentialForTax,
        sizeForTax: this.sizeForTax,
        degradingPotentialParameterName: this.degradingPotentialParameterName,
        sizeParameterName: this.sizeParameterName,
        qualifySimplifiedTechnicalParameters: this.qualifySimplifiedTechnicalParameters,
      };
      this.setFrameworkEntity(payload)
      this.nextStep()
    },
    fetch(searchTerm) {
      this.isLoading = true;
      TypologyService
          .fetchTypologies(searchTerm)
          .then(response => this.typologies = response.data)
          .finally(() => this.isLoading = false);
    },
    loadTechnicalParametersList(typology) {
      TechnicalParameterService
          .fetchTechnicalParameter(typology.id)
          .then(({data}) => {
            this.degradingPotentialParameterName = data.degrading_potentials_for_tax_name;
            this.degradingPotentialsForTax = data.degrading_potentials_for_tax;
            this.sizeParameterName = data.sizes_for_tax_name;
            this.sizesForTax = data.sizes_for_tax;

            this.technicalParameters = data.technical_parameters;
            this.technicalParametersFilled = reduce(data.technical_parameters, (acc, item) => {
              acc.push({id: item.id, value: '', porte_p: item.porte_p, name: item.name})
              return acc
            }, []);

            if (this.technicalParametersFilled && this.technicalParametersFilled.length) {
              const oneTechnicalParameterHasPorteP = this.technicalParametersFilled.some((item) => {
                return (item.porte_p !== null && item.porte_p !== undefined);
              });

              if (!oneTechnicalParameterHasPorteP) {
                this.qualifySimplifiedTechnicalParameters = false;
                this.showNotQualify = true;
              }
            }

            this.setApplicationTypesAvailable(data.checklists_available)
          })
          .catch(() => {
            this.$swal({
              title: 'Erro ao listar as tipologias/serviços',
              text: 'Entre em contato com o Suporte para reportar esse erro',
              type: 'error',
              confirmButtonText: 'Ok',
            })
          });
    },
  },
  computed: {
    ...mapGetters('newApplication', ['applicationSimplified']),
    noDataText() {
      if (this.typologies.length === 0) {
        if (this.isLoading) return 'Carregando...';

        if (this.search && this.search.length > 0) return 'Nenhum resultado com o termo buscado';

        return 'Nenhuma tipologia encontrada';
      }

      return 'Digite para buscar uma tipologia';
    },
  },
  watch: {
    typology(val) {
      this.loadTechnicalParametersList(val);
    },
    search(newVal) {
      if (newVal && newVal.length > 3) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
         this.fetch(newVal);
        }, 700)
      }
    },
    technicalParametersFilled: {
      handler() {
        if (!this.applicationSimplified) {
          return;
        }

        if (!this.applicationSimplified.qualify || !this.applicationSimplified.simplified) {
          this.showNotQualify = false;
          this.qualifySimplifiedTechnicalParameters = false;
          return;
        }

        if (this.technicalParametersFilled.some((item) => !item.value)) {
          this.qualifySimplifiedTechnicalParameters = null;
          this.showNotQualify = false;
        }

        const oneTechnicalParameterHasPorteP = this.technicalParametersFilled.some((item) => {
          return (item.porte_p !== null && item.porte_p !== undefined);
        });

        if (!oneTechnicalParameterHasPorteP) {
          this.qualifySimplifiedTechnicalParameters = false;
          this.showNotQualify = true;
          return;
        }

        const allTechnicalParametersQualify = this.technicalParametersFilled.every((item) => {
          return (item.porte_p === null || item.porte_p === undefined) || Number(item.value) <= item.porte_p;
        })

        this.qualifySimplifiedTechnicalParameters = allTechnicalParametersQualify;
        this.showNotQualify = !allTechnicalParametersQualify;
      }, deep: true,
    },
    valid() {
      this.setValidSteps(this.valid);
    }
  }
};
</script>
